import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { publishInsight } from 'action/insight'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, publishText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${publishText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${publishText}ed`
    },
    title: {
      error: `There has been an issue ${publishText}ing ${title}`,
      success: `Insight ${publishText}ed`
    }
  }
})

const PublishInsight = ({ publishInsight, insight: { uuid, title, published: isPublished, is_draft: isDraft }, pagination }) => {
  const publishText = isPublished ? 'unpublish' : 'publish'

  const handleSubmit = () => publishInsight(uuid)

  const { decide, outcome } = generateModalText(title, publishText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(publishText)} Insight`}</Button>
  )
}

PublishInsight.propTypes = {
  insight: PropTypes.object,
  pagination: PropTypes.object,
  publishInsight: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  publishInsight: bindActionCreators(publishInsight, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.insight.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishInsight)
